import './PairComparisonTable.scss'

import { useT } from '@eturi/react-i18next'
import type { Feature } from '@op/services'
import cls from 'classnames'
import { Glyph } from '../../widgets'

type PairComparisonTableProps = {
	readonly feature?: Feature
}

const PairComparisonTable = ({ feature }: PairComparisonTableProps) => {
	const [t] = useT('connect.connect_comparison')

	return (
		<section className="pair-cmp-table">
			<div className="pair-cmp-table__row">
				<p />
				<p className="pair-cmp-table__cell pair-cmp-table__cell--header">
					{t.$('actions.quick_pair')}*
				</p>
				<p className="pair-cmp-table__cell pair-cmp-table__cell--header">
					{t.$('actions.full_pair')}
				</p>
			</div>

			<FeatureRow included>{t('features.grants_blocks')}</FeatureRow>
			<FeatureRow included>{t('features.schedules')}</FeatureRow>
			<FeatureRow highlight={feature == 'ALLOWANCE'} included>
				{t('features.allowance')}
			</FeatureRow>
			<FeatureRow included>{t('features.family_locator')}</FeatureRow>
			<FeatureRow highlight={feature == 'VEW'} included>
				{t('features.view')}
			</FeatureRow>
			<FeatureRow highlight={feature == 'RESTRIX'}>{t('features.web_filter')}</FeatureRow>
			<FeatureRow highlight={feature == 'APP_RULES'}>{t('features.app_rules')}</FeatureRow>
			<FeatureRow>{t('features.text_blocking')}</FeatureRow>
			<FeatureRow>{t('features.app_organizer')}</FeatureRow>
			{/* <FeatureRow>{t('features.tamperproofing')}</FeatureRow> */}
		</section>
	)
}

export default PairComparisonTable

type FeatureRowProps = {
	readonly children: string
	readonly highlight?: boolean
	readonly included?: boolean
}

const FeatureRow = ({ children, highlight, included }: FeatureRowProps) => (
	<div className={cls('pair-cmp-table__row', highlight && 'bg-gray-95 rounded-lg')}>
		<h5 className="pair-cmp-table__cell pair-cmp-table__cell--title">{children}</h5>

		<Glyph
			className={cls('flex-center text-teal-2dk', !included && 'opacity-30')}
			name={included ? 'check' : 'x'}
			size="xs"
		/>

		<Glyph className="flex-center text-teal-2dk" name="check" size="xs" />
	</div>
)
